export default __webpack_public_path__ + "402b47bbea3fc71fd1d1f2dfc428d195.png";